import React, { useRef, useState, useEffect } from "react";
import { Grid, Typography, Button, Card } from "@material-ui/core";
import { routePaths } from "../../../../config/route-paths";
import { commonService } from "../../../../../services/common.service";
import { history } from "../../../../../helpers/index";
import { useSelector } from "react-redux";
import { paymentService } from "../model/e_razor-pay-service";
import { Skeleton } from "@material-ui/lab";
import PaymentConfirmationContent from "../../e_payment-confirmation/view/_payment-confirmation-content";
import { useReactToPrint } from "react-to-print";
import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import PaymentConfirmationHeader from "../../e_payment-confirmation/view/_payment-confirmation-header";
import PostPaymentHandling from "../../e_payment-confirmation/view/_post-payment-handling";
import { useMediaQuery } from "react-responsive";

const useStyles = makeStyles((theme) => ({
  paymentConfirmationContainer: {
    height: "555px"
  },
  marginLeft: {
    marginLeft: "4% !important"
  },
  containerHeight: {
    height: "555px"
  },
  divHeight: {
    height: "100%"
  },
  heightGrid: {
    height: "80%"
  },
  imgStyle: {
    height: "75%",
    margin: "auto 20px 20px auto"
  },
  imgMobileStyle: {
    height: "65%",
  },
  fullWidth: {
    width: "100%"
  },
  imageGrid: {
    display: "flex"
  }
}))

export default function PaymentConfirmation(
  { response, location },
  props
) {
  const [paymentError, setPaymentError] = useState();
  const classes = useStyles()
  const [successImg, setSuccessImgPath] = useState();
  const [errorImg, setErrorImgPath] = useState();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 550px)" })

  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  let successImgCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_PAYMENT_CONFIRMATION_SUCCESS_IMG
  );
  let errorImgCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_PAYMENT_CONFIRMATION_ERROR_IMG
  );
  useEffect(() => {
    if(successImgCode){
      commonService.getAssestUrl(successImgCode).then((res) => setSuccessImgPath(res));
    }
  if(errorImgCode){
    commonService.getAssestUrl(errorImgCode).then((res) => setErrorImgPath(res));
  }
  
  }, [successImgCode, errorImgCode]);

  useEffect(() => {
    if (paymentError?.status === "RETRY_NOT_ALLOWED") {
      localStorage.removeItem("bearer");
      history.push(routePaths.LOGOUT);
    }
  }, [paymentError]);

  let labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_AUTH_PAYMENT_CONFIRMATION
  );
  let accountDetails = useSelector(
    (store) =>
      store?.FAccountInformation?.personAcccountDetail?.personAccountList
  );
  let [accountId, setAccountId] = useState();
  useEffect(() => {
    if (location === "payment") {
      accountDetails.forEach((item) => {
        item.accountId === response?.mainData?.head?.accountId &&
          setAccountId(item.accountId);
      });
    } else if (location === "billpay") {
      setAccountId(response?.mainData?.head?.billId);
    }
  }, [location, accountDetails]);

  return (
    <>
      {isTabletOrMobile ? (
        <Grid container
          className={classes.containerHeight}
        >
          <div className={classes.divHeight}
          >
            {labels ? (
              <>
                <PaymentConfirmationHeader
                  response={response}
                  accountId={accountId}
                  location={location}
                  paymentError={paymentError}
                />
                <Grid container className={classes.heightGrid}
                  direction="row"
                >
                  <Grid item xs={7}>
                    <PaymentConfirmationContent
                      response={response}
                      accountId={accountId}
                      location={location}
                      paymentError={paymentError}
                    />
                    <br />
                    <div className={classes.marginLeft}>
                      {" "}
                      <PostPaymentHandling
                        response={response}
                        accountId={accountId}
                        location={location}
                        paymentError={paymentError}
                      />
                    </div>
                  </Grid>
                  <Grid item className={classes.imageGrid} xs={5}>
                    {
                      paymentError?.isInError === "true" ||
                        response?.mainData?.errorInformation?.isInError === "true" ? (
                        <img src={errorImg?.assetPath}
                          className={classes.imgStyle}
                          alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_ERROR_FALLBACK_TEXT}
                        >
                        </img>
                      ) : (
                        <img src={successImg?.assetPath}
                          className={classes.imgStyle}
                          alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS_FALLBACK_TEXT}
                        >
                        </img>
                      )
                    }
                  </Grid>
                </Grid>
              </>
            ) : (
              <Skeleton />
            )}
          </div>
        </Grid>
      ) :
        (
          <Grid container 
            direction="column"
          >
            <div className={classes.divHeight}
            >
              {labels ? (
                <>
                  <PaymentConfirmationHeader
                    response={response}
                    accountId={accountId}
                    location={location}
                    paymentError={paymentError}
                  />
                  <Grid container>
                    <Grid container
                      justify="center">
                      {
                        paymentError?.isInError === "true" ||
                          response?.mainData?.errorInformation?.isInError === "true" ? (
                          <img src={errorImg?.assetPath}
                            className={classes.imgMobileStyle}
                            alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_ERROR_FALLBACK_TEXT}
                          >
                          </img>
                        ) : (
                          <img src={successImg?.assetPath}
                            className={classes.imgMobileStyle}
                            alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS_FALLBACK_TEXT}
                          >
                          </img>
                        )
                      }
                    </Grid>
                    <Grid item
                      className={classes.fullWidth}
                      xs={12}>
                      <PaymentConfirmationContent
                        response={response}
                        accountId={accountId}
                        location={location}
                        paymentError={paymentError}
                      />
                      <br />
                      {" "}
                      <PostPaymentHandling
                        response={response}
                        accountId={accountId}
                        location={location}
                        paymentError={paymentError}
                      />
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Skeleton />
              )}
            </div>
          </Grid>
        )
      }
    </>
  );
}
